import { render, staticRenderFns } from "./DuplicateReviewCard.vue?vue&type=template&id=b9e5787e&scoped=true"
import script from "./DuplicateReviewCard.vue?vue&type=script&lang=js"
export * from "./DuplicateReviewCard.vue?vue&type=script&lang=js"
import style0 from "./DuplicateReviewCard.vue?vue&type=style&index=0&id=b9e5787e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e5787e",
  null
  
)

export default component.exports